import { render, staticRenderFns } from "./GamesMore.vue?vue&type=template&id=5a110d53&scoped=true"
import script from "./GamesMore.vue?vue&type=script&lang=js"
export * from "./GamesMore.vue?vue&type=script&lang=js"
import style0 from "./GamesMore.vue?vue&type=style&index=0&id=5a110d53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a110d53",
  null
  
)

export default component.exports